<template>
  <section class="section-base form-section-base">
    <div class="form-section-base__title">Подать заявление как:</div>
    <v-container>
      <div class="form-section-base__controls">
        <v-row>
          <v-col>
            <v-radio-group v-model="fillType">
              <v-radio :label="manualLabel" :value="FillType.MANUAL" />
              <v-radio
                :label="SubjectFillTypeText.MACHINE"
                :value="FillType.MACHINE"
              />
            </v-radio-group>
          </v-col>
        </v-row>
      </div>

      <Footer
        @next-btn-click="
          () =>
            leaveStep({
              stepThis: this,
              direction: StepDirection.NEXT,
              step: StepName.S1,
            })
        "
        :first-step="true"
        :loading-next="loadingNext"
      />
    </v-container>
  </section>
</template>

<script>
import { Role } from '@/utils/dictionaries';
import { leaveStep } from '@/utils/services';
import Footer from '@/components/services/elements/Footer';
import { StepDirection, StepName } from '@/types/services';
import {
  ApplicantRoleConst,
  SubjectFillTypeText,
  SubjectType,
} from '@/constants';
import { ServicesModule } from '@/store/modules/services';
import { getSubjectTitle } from '@/utils/common';

const FillType = {
  MANUAL: 'manual',
  MACHINE: 'machine',
};

export default {
  name: 'StepSelectMrpa',
  props: {
    loadingNext: {
      type: Boolean,
      required: true,
    },
    roleType: {
      type: String,
      required: true,
    },
    statementType: {
      type: String,
      required: true,
    },
  },
  components: {
    Footer,
  },
  data() {
    return {
      SubjectFillTypeText,
      StepDirection,
      StepName,
      leaveStep,
      Role,
      FillType,
      fillType: FillType.MANUAL,
      invalidFields: [],
    };
  },
  computed: {
    manualLabel() {
      return getSubjectTitle({
        statementType: this.statementType,
        role: this.roleType,
        subjectType: SubjectType.APPLICANT,
      });
    },
  },
  created() {
    this.prefillDraft();
  },
  methods: {
    prefillDraft() {
      const applicantRole = ServicesModule.statement.applicantRole;

      if (applicantRole) {
        this.fillType =
          applicantRole === ApplicantRoleConst.APPLICANT
            ? FillType.MANUAL
            : FillType.MACHINE;
      }
    },
    touchFields() {},
    assemblyModel() {
      return this.fillType === FillType.MANUAL
        ? ApplicantRoleConst.APPLICANT
        : ApplicantRoleConst.TRUSTEE;
    },
  },
};
</script>
